import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { LazyLoadEvent, SelectItem } from 'primeng';
import { ITaskInfo } from '../../interfaces/task-info';
import { JobsTasksGridComponent } from './jobs-tasks-grid.component';

export enum InboxType {
  VmeInbox = 1,
  SupplierExistingJobs = 2,
  CustomerInbox = 3,
}

@Component({
  selector: 'vme-jobs-tasks',
  templateUrl: './vme-jobs-tasks.component.html',
})
export class VmeJobsTasksComponent implements OnInit {
  @ViewChild('taskgrid')
  taskgrid: JobsTasksGridComponent;

  public isMapMode: boolean;

  private _inboxType: InboxType;
  @Input('inboxType')
  set inboxType(value: InboxType) {
    this._inboxType = value;
  }
  get inboxType(): InboxType {
    return this._inboxType;
  }

  private _selectedTask: ITaskInfo;
  @Output() selectedTaskChange: EventEmitter<ITaskInfo>;
  @Input('selectedTask')
  set selectedTask(value: any) {
    this._selectedTask = value;
    this.selectedTaskChange.emit(value);
  }
  get selectedTask(): any {
    return this._selectedTask;
  }

  public msgs: any[];

  @Output() totalCountChanged: EventEmitter<any>;

  private _customers: SelectItem[] = [];
  @Input('customers')
  set customers(value: SelectItem[]) {
    this._customers = value;
  }
  get customers(): SelectItem[] {
    return this._customers;
  }

  private _suppliers: SelectItem[] = [];
  @Input('suppliers')
  set suppliers(value: SelectItem[]) {
    this._suppliers = value;
  }
  get suppliers(): SelectItem[] {
    return this._suppliers;
  }

  constructor() {
    this.selectedTaskChange = new EventEmitter<ITaskInfo>();
    this.totalCountChanged = new EventEmitter<any>();
  }

  ngOnInit() {
    this.isMapMode = false;
  }

  onTaskChanged(item: any) {
    console.log(item);
    //this.selectedTask = event.data;
    this.selectedTaskChange.emit(item);
  }

  gridUpdate() {
    this.taskgrid.gridUpdate();
  }

  search() {
    this.taskgrid.search();
  }

  deselectTask() {
    this.taskgrid.deselectTaskFromInbox();
  }

  totalCountChange(event) {
    this.totalCountChanged.emit(event);
  }
}
